import React, { useState, useEffect } from 'react';
import { getWeekNumber } from '../../../../utils/Common'
import TableHeadsData from './tableHeadsData';
import BloquesCargados from './Bloquescargados';
import vr from '../../../../utils/Verifiers';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import EditorSemanasInventarioCampoExterno from './microcomponentes/EditorSemanasInventarioCampoExterno';
import { set } from 'lodash';

const ExcelCargados = (p) => {
    const weekN = getWeekNumber(new Date());
    const [loader, setloader] = useState(false);
    const [lista, setlista] = useState([]);
    const [headers, setheaders] = useState([]);
    const [semanas, setsemanas] = useState([]);
    const [paginador, setpaginador] = useState({ page: 1, tipo: 0, per_page: 50, semana: "", total_pages: 0, total_regs: 0, tipo_semana: "siembra", filtro: "no vinculado" });
    const [paginas, setpaginas] = useState([]);
    const [showCargas, setshowCargas] = useState(false);
    const [dialog, setdialog] = useState({ show: false });
    const [editar, seteditar] = useState(null);
    useEffect(() => {
        getInventario();
        setheaders([
            'bloque',
            'semana_siembra',
            'dia_siembra',
            'fecha_siembra',
            'semana_trasplante',
            'dia_trasplante',
            'fecha_trasplante',
            'dias_vivero',
            'semana_cosecha',
            'fecha_cosecha',
            'plantas_presupuesto',
            'conteo_plantas',
            'perdidas',
            'numero_plantas',
            'rancho',
            'valvula',
            'tunel_inicio',
            'tunel_fin',
            'cama_inicio',
            'cama_fin',
            'largo_cama',
            'metros2_siembra',
            'grados_dia_desde_trasplante',
            'tallos_recuperados',
            'num_etiqueta',
            'germinacion',
            'cargado_por',
            'fecha_carga',
            'reg_vivero',
            'reg_siembra_directa',
            'reg_plan_campo',
            'reg_inventario_campo',
            'reg_ejecucion_campo',
            'reg_conteos'
        ]);
    }, []);

    async function getInventario(pg = { ...paginador }) {
        const resp = await vr.getDataAPI('campo/v2/inventario_campo/externo/get', { ...pg }, setloader);
        if (resp.estatus === false) return;
        const paginacion = resp.data.paginacion;
        setpaginador({
            ...pg,
            page: paginacion.pagina_actual,
            per_page: paginacion.por_pagina,
            total_pages: paginacion.total_paginas,
            total_regs: paginacion.total
        });

        const listt = resp.data.data.map(d => {
            d.reg_vivero = d.plan_cosecha_id ? 'SI' : 'NO';
            d.reg_siembra_directa = d.siembra_directa_id ? 'SI' : 'NO';
            d.reg_plan_campo = d.planeacion_campo_id ? 'SI' : 'NO';
            d.reg_inventario_campo = d.inventario_campo_id ? 'SI' : 'NO';
            d.reg_ejecucion_campo = d.ejecucion_plan_campo_id ? 'SI' : 'NO';
            d.reg_conteos = d.conteos_id ? 'SI' : 'NO';
            return d;
        });

        setlista([...listt]);

        const pagss = [];
        for (let i = 0; i < paginacion.total_paginas; i++) pagss.push(i + 1);
        setpaginas(pagss);

        setsemanas([...resp.data.semanas.map(s => ({ semana: s }))]);
        //if (listt.length > 0) seteditar(listt[0]);
    }

    const changeAndLoad = (e) => {
        let p = { ...paginador };
        p[e.target.name] = e.target.value;
        if (['semana', "tipo_semana"].includes(e.target.name)) p.page = 1;
        if (e.target.name === 'tipo_semana') p.semana = '';
        getInventario(p);
    }

    const changePage = (back) => {
        let p = { ...paginador };
        if (back && p.page > 1) {
            p.page--;
            setpaginador(p);
            getInventario(p);
        } else if (!back && p.page < p.total_pages) {
            p.page++;
            setpaginador(p);
            getInventario(p);
        }
    }

    const jumpPage = (e) => {
        let newPage = parseInt(e.target.value);
        if (paginador.page != newPage) {
            let p = { ...paginador };
            p.page = newPage;
            setpaginador(p);
            getInventario(p);
        }
    }

    const abrirEditor = (data) => {
        if (data.plan_cosecha_id || data.siembra_directa_id) {
            vr.activeDialog(setdialog, 'No es posible editar un bloque que ya está asociado a un plan de campo o siembra directa.', 'ACCIÓN NO PERMITIDA', 'error');
            return;
        }
        seteditar(data);
    }

    const vincularExistentes = async () => {
        const resp = await vr.getDataAPI('campo/v2/inventario_campo/externo/vincular', {}, setloader, setdialog);
        if (!resp.estatus) return;
        vr.activeDialog(setdialog, resp.msj, 'VINCULACIÓN COMPLETADA', 'success');
        getInventario();
    }

    if (showCargas) return (<BloquesCargados change={() => { setshowCargas(false) }} actualizarFecha={p.actualizarFecha} />)
    else return (
        <>
            <div className="col-lg-12 overflow m-0 p-2 mt-2" style={{ maxHeight: '76vh', overflow: 'auto' }}>
                <div className='row justify-content-center p-0 m-0'>
                    <div className='form-group m-2 bw-200'>
                        <label className='text-bold text-s'>Filtro de vinculación</label>
                        <select className='form-control form-control-sm text-center shadow' name='filtro' value={paginador.filtro} onChange={changeAndLoad}>
                            <option value='todos' >Todos los resutados</option>
                            <option value='vinculado' >Vinculados</option>
                            <option value='no vinculado' >Sin vincular</option>

                        </select>
                    </div>
                    <div className='form-group m-2 bw-200'>
                        <label className='text-bold text-s'>Núm. Semana</label>
                        <select className='form-control form-control-sm text-center shadow' name='semana' value={paginador.semana} onChange={changeAndLoad}>
                            <option value='' >Seleccione una</option>
                            {
                                semanas.map((sem, i) => {
                                    return (
                                        <option value={sem.semana} key={'semana siembra' + i}>{sem.semana}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                    <div className='form-group m-2 bw-200'>
                        <label className='text-bold text-s'>Tipo de semana</label>
                        <select className='form-control form-control-sm text-center shadow' name='tipo_semana' value={paginador.tipo_semana} onChange={changeAndLoad}>
                            <option value='' >Seleccione una</option>
                            {
                                ['siembra', 'trasplante', 'corte'].map((sem, i) => {
                                    return (
                                        <option value={sem} key={'tipo_semana' + i + sem}>{sem.toUpperCase()}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                    <div className='form-group p-1 text-center bw-200'>
                        <label className='text-bold text-s w-100'>
                            <span className='text-xs'>Página:</span> ({paginador.page} / {paginador.total_pages})
                            <span className='ms-2 text-xs'>Registros:</span> {paginador.total_regs}
                        </label>
                        <div className="btn-group w-100 bg-warning" role="group" >
                            <button type="button" className="w-30 btn btn-sm btn-dark certus-bg-gradient-black shadow-sm text-white"
                                disabled={paginador.page === 1}
                                onClick={() => { changePage(true) }}>❮</button>
                            <select className='form-control form-control-sm text-center border w-40' value={paginador.page} onChange={jumpPage}>
                                {
                                    (paginas ?? []).map((pag, i) => {
                                        return (
                                            <option value={pag} key={i + "pagina" + pag} className='ps-3 pe-3'>{pag}</option>
                                        )
                                    })
                                }
                            </select>
                            <button type="button" className="w-30 btn btn-sm btn-dark certus-bg-gradient-black shadow-sm text-white"
                                disabled={paginador.page === paginador.total_pages}
                                onClick={() => { changePage(false) }}>❯</button>
                        </div>
                    </div>

                    <div className='form-group m-2 contenedor-bottom' style={{ width: '150px' }}>
                        <button className='btn btn-sm btn-light shadow' onClick={() => { setshowCargas(true) }}>Historial de cargas</button>
                    </div>

                    <div className='form-group m-2 contenedor-bottom' style={{ width: '200px' }}>
                        {paginador.filtro === 'no vinculado' && lista.length > 0 &&
                            <button className='btn btn-warning text-bold border border-dark btn-sm shadow w-100' onClick={vincularExistentes}>Ejecutar vinculación</button>}
                    </div>

                    <div className='col-lg-12'></div>
                    {lista.length > 0 && <TableHeadsData data={lista} heads={headers} styleName={{ width: '100% !important', height: '68vh' }} action={abrirEditor} />}

                </div>
                {loader && <div className='blur-s' style={{ width: '100vw', height: '100vh', position: 'fixed', left: 0, top: 0 }}><div className='loader'></div></div>}
            </div>
            <VainillaDialog data={dialog} />
            {editar && <EditorSemanasInventarioCampoExterno close={(refresh) => {
                seteditar(null);
                if (refresh) getInventario();
            }} data={editar} />}
        </>
    )
}

export default ExcelCargados;